import { render, staticRenderFns } from "./TheAlert.vue?vue&type=template&id=e3925292"
import script from "./TheAlert.vue?vue&type=script&lang=js"
export * from "./TheAlert.vue?vue&type=script&lang=js"
import style0 from "./TheAlert.vue?vue&type=style&index=0&id=e3925292&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports